import { render, staticRenderFns } from "./FourPointFiveStars.vue?vue&type=template&id=e1c87f36&scoped=true&"
import script from "./FourPointFiveStars.vue?vue&type=script&lang=js&"
export * from "./FourPointFiveStars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c87f36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
